function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18476",
  d: "M8.739 68.838a22.994 22.994 0 010-32.525L36.313 8.739A23 23 0 1168.84 41.264L41.264 68.838a22.994 22.994 0 01-32.525 0z",
  fill: "#fee8cc"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2772",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2773",
  transform: "translate(-57.76 -24)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1449",
  transform: "translate(68.76 34)",
  fill: "#fff",
  stroke: "#1d1f2c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 58,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 35,
  height: 56,
  rx: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1451",
  d: "M87.26 59h0a8.5 8.5 0 018.5 8.5v.556a.944.944 0 01-.944.944H79.704a.944.944 0 01-.944-.944V67.5a8.5 8.5 0 018.5-8.5z",
  fill: "#fff",
  stroke: "#fb8c00"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 359",
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  transform: "translate(82.76 50)",
  fill: "#fff",
  stroke: "#fb8c00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18530",
  d: "M78.76 74h17",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18537",
  d: "M70.226 85h34.666",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18538",
  d: "M70.226 44h34.666",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18531",
  d: "M78.76 78h17",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2774",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18532",
  d: "M85.76 39h6.5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18533",
  d: "M81.76 39h1"
}))), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18536",
  d: "M56.049 69.975l-.053.023v-.049a28.958 28.958 0 01-9.762-7.783C41.759 56.646 42 46.553 42 46.553v-7.854l14-3.672V35l.053.014.053-.014v.029L70.1 38.701v7.854s.24 10.094-4.234 15.613a29.027 29.027 0 01-9.76 7.783V70z",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2770",
  transform: "translate(-85 1)",
  stroke: "#fb8c00"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1406",
  width: 8,
  height: 14,
  rx: 4,
  transform: "translate(137 42)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1405",
  transform: "translate(134 47)",
  fill: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 12,
  height: 8,
  rx: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18465",
  d: "M141 52.734V51",
  fill: "none",
  strokeLinecap: "round"
})));

var SvgEncrypt = function SvgEncrypt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 35 \\u2013 1",
    width: 77,
    height: 77
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgEncrypt as ReactComponent };